import { render, staticRenderFns } from "./channel.overview.vue?vue&type=template&id=4bcbdd9e&"
import script from "./channel.overview.vue?vue&type=script&lang=js&"
export * from "./channel.overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports